
const Home = () => {  
  return (
  <>
    {/* <h1 style={{"right": "50%", "top": "50%"}}>Home</h1> */}
    {/* <GeneralInput /> */}
  </>
  )
}

export default Home